/* eslint-disable */
/*
Purpose: the root container

Notes: this setup will probably change, as flippingn between stack navigation with and without token is awkward
*/

import React, { Component } from 'react'
import { View, Text, StatusBar, AppState, Dimensions } from 'react-native'
import ReduxNavigation from '../Navigation/ReduxNavigation'
import { connect } from 'react-redux'
import StartupActions from '../Redux/StartupRedux'
import ReduxPersist from '../Config/ReduxPersist'
import styles from './Styles/RootContainerStyles'
import AuthActions from '../Redux/AuthRedux'

import { KargoeConfig } from '../Config/AppConfig'


const screenHeight = Dimensions.get('window').height

class RootContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appState: 'active'
    }
    this.navigation = null
  }

  componentDidMount () {
    if (!ReduxPersist.active) {
      console.log("in root container component did mount ready to call startup = " + this.props.startup)
      this.props.startup()
    }
    // comment this out to try to test persistent login
    //else
    //this.props.startup() // do anyway for web test 
    AppState.addEventListener('change', this.handleAppStateChange)
  }

  componentWillUnmount () {
    AppState.removeEventListener('change', this.handleAppStateChange)
  }

  handleAppStateChange = (nextAppState) => {
    if (this.state.appState.match(/inactive|background/) && nextAppState === 'active') {
      // nothing
    }
    this.setState({appState: nextAppState})
  }

  setNavigation = nav => this.navigation = nav

  render() {
      console.log("root container render")
      // <Text style={{position: 'absolute', top: 10, left: 10, color: 'black', backgroundColor: 'orange', fontSize: 14, lineHeight: 16, transform: [{ rotate: '90deg'}]}}>{`Dev`}</Text>
      const hasNotch = screenHeight > 800
      const onScreenIdentifier = KargoeConfig.onScreenIdentifier
      // leave off web for now, no data for this yet except dev / prod / stage
      const whoAmIView = (onScreenIdentifier && false) ? (
        <Text style={{position: 'absolute', top: 0, left: hasNotch ? 30 : 0, color: onScreenIdentifier.color, backgroundColor: onScreenIdentifier.bgColor, fontSize: 10, lineHeight: 10, padding: 1}}>{onScreenIdentifier.label}</Text>
      ) : null
      console.log("root container render this.props.outofdate = " + this.props.outofdate)
      return (false && this.props.outofdate) ? (<View></View>) : (
        <View style={styles.applicationView}>
          <StatusBar barStyle='light-content' />
          <ReduxNavigation needsLoginTimeStamp={this.props.needsLoginTimeStamp} setNavigation={this.setNavigation.bind(this)} />
          {whoAmIView}
        </View>
      )
  }
}

const mapStateToProps = state => ({
    auth: state.auth
  , outofodate : state.user.outofdate
  })

// wraps dispatch to create nicer functions to call within our component
const mapDispatchToProps = (dispatch) => ({
  startup: () => dispatch(StartupActions.startup()),
  renewToken: (token) => dispatch(AuthActions.renewToken(token))
})

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef : true })(RootContainer)
